import api from '../services/api';

export const resolveAuthenticatedFileUrl = (url: string): string => {
  const target = new URL(url, window.location.origin);
  if (target.origin !== window.location.origin) {
    throw new Error('Arquivo protegido deve usar uma URL da própria aplicação.');
  }

  const apiBase = (api.defaults.baseURL ?? '').replace(/\/$/, '');
  return apiBase && target.pathname.startsWith(`${apiBase}/`)
    ? `${target.pathname.slice(apiBase.length)}${target.search}`
    : `${target.pathname}${target.search}`;
};

export const fetchAuthenticatedFile = async (url: string, signal?: AbortSignal): Promise<Blob> => {
  const response = await api.get<Blob>(resolveAuthenticatedFileUrl(url), {
    responseType: 'blob',
    signal,
  });
  return response.data;
};

export const downloadAuthenticatedFile = async (url: string, fileName: string): Promise<void> => {
  const blob = await fetchAuthenticatedFile(url);
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
};
